// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1j2CL","tab":"ProcedureTabs_tab__2ivzw"};